import { Box, ButtonBase, useTheme, Typography, Link, Grid, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ROUTE_NAMES from "routes/routeNames";

function FrontFooter() {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        background: theme.palette.mode === "dark" ? "#121212" : "#ffffff",
        color: theme.palette.mode === "dark" ? "#ffffff" : "#333333",
        padding: "20px 0",
        textAlign: "center",
      }}
    >
      {/* Footer Content - Links on Left, Download Buttons on Right */}
      <Grid container justifyContent="space-between" alignItems="center" sx={{ maxWidth: "80%", margin: "0 auto" }}>

        {/* Navigation Links (Left Side) */}
        <Grid item>
          <ButtonBase onClick={() => navigate(ROUTE_NAMES.FRONT_ROUTES.PRIVACY)}>
            <Typography variant="body2" sx={{ fontWeight: "bold", color: "inherit", px: 2 }}>
              Privacy Policy
            </Typography>
          </ButtonBase>
          <ButtonBase onClick={() => navigate(ROUTE_NAMES.FRONT_ROUTES.TERMS)}>
            <Typography variant="body2" sx={{ fontWeight: "bold", color: "inherit", px: 2 }}>
              Terms of Use
            </Typography>
          </ButtonBase>
          <ButtonBase onClick={() => navigate(ROUTE_NAMES.FRONT_ROUTES.CONTACT)}>
            <Typography variant="body2" sx={{ fontWeight: "bold", color: "inherit", px: 2 }}>
              Contact Us
            </Typography>
          </ButtonBase>
        </Grid>

        {/* Download Buttons (Right Side) */}
        <Grid item sx={{ textAlign: { xs: "center", md: "right" }, lineHeight: 1.6, mb: 2 }}>
          <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1, textAlign: "center" }}>
            Download Out In Service App:
          </Typography>
          <Link href="#" target="_blank">
            <img src="google.png" alt="Google Play" width="140px" style={{ borderRadius: "6px", marginRight: "10px" }} />
          </Link>
          <Link href="#" target="_blank">
            <img src="apple.png" alt="App Store" width="140px" style={{ borderRadius: "6px" }} />
          </Link>
        </Grid>
      </Grid>

      {/* Divider */}
      <Divider sx={{ width: "80%", margin: "16px auto" }} />

      {/* Copyright */}
      <Typography variant="body2" sx={{ fontSize: "14px", opacity: 0.9 }}>
        © {new Date().getFullYear()} Out In Service. All rights reserved. <br></br>Out In Service is not produced in conjunction with nor affiliated with the Watch Tower Bible and Tract Society of Pennsylvania or its related corporations. 
      </Typography>
    </Box>
  );
}

export default FrontFooter;
